import React from 'react';
import { Icon, Label, TextBlock } from '@sato/components';

import { IListItem, ParsedEntry } from '@/contentful/types';

export const ListItem = ({ icon, title, body }: ParsedEntry<IListItem>) => (
  <li className="flex gap-3 py-3">
    {icon?.icon && <Icon icon={icon.icon} size="md" />}

    <div className="self-center">
      {title && <Label component="p">{title}</Label>}

      {body && <TextBlock bodyVariant="normal">{body}</TextBlock>}
    </div>
  </li>
);
